import { render, staticRenderFns } from "./PphMix.vue?vue&type=template&id=739f0964&scoped=true"
import script from "./PphMix.vue?vue&type=script&lang=js"
export * from "./PphMix.vue?vue&type=script&lang=js"
import style0 from "./PphMix.vue?vue&type=style&index=0&id=739f0964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f0964",
  null
  
)

export default component.exports